/**
 * UseCaseProfile — UML Use Case diagrams.
 * See plans/software-design/domain.md § 8.
 */

import type { DomainDataProfile } from '../../../core/data-profiles';
import type { DiagramType } from '../../../lib/diagram/registries';

export type UseCaseNodeType = 'uc_actor' | 'uc_usecase' | 'uc_system';
export type UseCaseEdgeType = 'uc_include' | 'uc_extend' | 'uc_generalization' | 'uc_association';

export const UseCaseProfile: DomainDataProfile<UseCaseNodeType, UseCaseEdgeType> = {
  domainId: 'usecase',
  profileVersion: '1.0',
  diagramTypes: ['uml' as DiagramType],
  nodeTypes: ['uc_actor', 'uc_usecase', 'uc_system'],
  edgeTypes: ['uc_include', 'uc_extend', 'uc_generalization', 'uc_association'],
  vocabulary: {
    recordSingular: 'Use Case',
    recordPlural: 'Use Cases',
    repositoryLabel: 'System',
    hierarchyLabel: 'Include / Extend',
    importAction: 'Import Use Cases',
    keyColumnHint: 'Use Case',
    commitLabel: 'Push Use Cases',
    pullLabel: 'Refresh Use Cases',
    diagramLabel: 'use case diagram',
  },
  fieldAliases: {
    name: ['useCase', 'usecase', 'actorName'],
  },
  requiredProps: ['name'],
  recommendedProps: [],
  primaryShapeType: 'uc_usecase',
  propsToAttrsMapping: {
    name: 'name',
    stereotype: 'stereotype',
  },
  relationshipPackId: 'software-design-relationships',
};
